export function TrakLogo({ size = 24, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* headset band arcing over the head */}
      <path d="M4.5 12 a7.5 7.5 0 0 1 15 0" />
      {/* ear cups */}
      <rect x="2.7" y="11" width="2.6" height="4.6" rx="1.3" fill="currentColor" stroke="none" />
      <rect x="18.7" y="11" width="2.6" height="4.6" rx="1.3" fill="currentColor" stroke="none" />
      {/* mic boom + tip */}
      <path d="M4 15.4 v1.1 a1.3 1.3 0 0 0 1.3 1.3 H9.2" />
      <circle cx="9.4" cy="17.8" r="0.9" fill="currentColor" stroke="none" />
      {/* inverted-triangle head */}
      <path d="M7.6 9.4 H16.4 L12 16.4 Z" fill="currentColor" stroke="currentColor" strokeWidth="1.1" />
    </svg>
  );
}
